if ( typeof ImageHotspots !== 'function' ) {

  class ImageHotspots extends HTMLElement {

    constructor(){
			
      super();

			this._prefix = window.KT_PREFIX || '';

      this.daysEl = this.querySelector('.days');
			this.zIndex = 9;
			      
      this.hotspots = this.querySelectorAll(
				`.${this._prefix}image-hotspots__spot--bullet`
			);
			let previoushotspot = null;

			this.hotspots.forEach((hotspot) => {
				hotspot.addEventListener("click", (event) => {
					// Get the actual bullet element (in case user clicks the img inside)
					let targetBullet = event.target.closest(`.${this._prefix}image-hotspots__spot--bullet`);
					
					if (previoushotspot && previoushotspot !== targetBullet) {
						previoushotspot.classList.remove("active");
					}
					targetBullet.classList.toggle("active");
					targetBullet.parentNode.style.zIndex = this.zIndex++;
					previoushotspot = targetBullet;
					event.stopPropagation();
				});
			});

			document.addEventListener("click", (event) => {
				this.hotspots.forEach((hotspot) => {
					hotspot.classList.remove("active");
				});
				previoushotspot = null;
			});

    }

  }

  if ( typeof customElements.get('image-hotspots') == 'undefined' ) {
    customElements.define('image-hotspots', ImageHotspots);
  }

}

if ( Shopify.designMode ) {
	document.addEventListener("shopify:block:select", (e) => {
		const block = e.target;
		if ( block.classList.contains(`.${this._prefix}image-hotspots__spot`) ) {
			const bulletElements = document.querySelectorAll(
				".image-hotspots__spot--bullet"
			);
			bulletElements.forEach((bulletElement) => {
				bulletElement.classList.remove("active");
			});
			const activeBullet = block.querySelector(`.${this._prefix}image-hotspots__spot--bullet`);
			activeBullet.classList.add('active');
		}
	})
}